import React from 'react';
import { TApkType, TParametersOfApkType } from 'types';
import CutoverCheckbox from './components/CutoverCheckbox';
import ApkTypeSelect from './components/ApkTypeSelect';
import style from './ApkTypeField.module.scss';

interface IApkTypeField {
	parameterOfApkType: Nullable<TParametersOfApkType>;
	IDSelectedApkType: Nullable<TApkType>;
	isCutoverBeforeUpdate: boolean;
	setIDApkType: (value: Nullable<TApkType>) => void;
	toggleCutoverBeforeUpdate: () => void;
}

const ApkTypeField: React.FC<IApkTypeField> = ({
	parameterOfApkType,
	isCutoverBeforeUpdate,
	IDSelectedApkType,
	setIDApkType,
	toggleCutoverBeforeUpdate,
}) => {
	return (
		<div className={style.container}>
			<ApkTypeSelect setIDApkType={setIDApkType} parameterOfApkType={parameterOfApkType} />
			{IDSelectedApkType === 2 && (
				<CutoverCheckbox
					isCutoverBeforeUpdate={isCutoverBeforeUpdate}
					toggleCutoverBeforeUpdate={toggleCutoverBeforeUpdate}
				/>
			)}
		</div>
	);
};

export default React.memo(ApkTypeField);
